import ViewsAcknowledgement from '@/views/acknowledgement/ViewsAcknowledgement.vue';
import {RouteRecordRaw} from 'vue-router';

export default [{
    path: '/acknowledgement',
    name: 'acknowledgement',
    component: ViewsAcknowledgement,
    meta: {
        requiresAuth: true
    }
}] as RouteRecordRaw[]
